import { useRef } from "react";
import * as S from "./styles";
import { useCapture } from "../../../hooks/use-capture";
import { CaptureButton } from "../../../component/CaptureButton";
import { useCopyTournamentText } from "../../../hooks/use-copy-tournament-text";
import { formatNumber } from "../../../utils/timer";
import AdVideo from "../../../component/AdVideo";
import { useClock } from "../hooks/use-clock";
import { Helmet } from "react-helmet";
import TimerCommonStack from "../component/stack";
import TimerPrizeAndNotice from "../component/prize-and-notice";

const UserTimer1 = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { handleCapture } = useCapture();
  const { copyTournamentText } = useCopyTournamentText();

  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    visibleRanks,
    getNextBlind,
    getNowBlind,
    findNextLevel,
    getData,
    subPrizeFont,
  } = useClock();

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <S.UserTimer1Wrapper ref={containerRef}>
        {backgroundImage && (
          <S.Timer3Background backgroundImage={backgroundImage} />
        )}

        <S.UserTimer1LeftWrapper>
          <S.UserTimer1TimerInfoWrapper>
            <S.UserTimer1TimerInfoHeader>
              <div className="left">
                {coverImage && <img src={coverImage} alt="logo" />}
                <div className="info-row">
                  <div className="title">{data?.title}</div>
                  {data?.subTitle ? (
                    <div className="type">{data?.subTitle}</div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="pub-name">{pub?.cafeName}</div>
            </S.UserTimer1TimerInfoHeader>
            <S.UserTimer1TimerInfoNowLevel>
              {timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs > 0 ? (
                timeInfo.currentLevel?.type === "LEVEL" ? (
                  `현재\u00A0\u00A0\u00A0${timeInfo.currentLevel.level}LV`
                ) : (
                  <span className="break-text">
                    BREAK(다음 {findNextLevel()}LV)
                  </span>
                )
              ) : (
                "시작 준비중"
              )}
            </S.UserTimer1TimerInfoNowLevel>

            <S.UserTimer1TimerInfoTime
              isBreak={
                !!(
                  timeInfo.currentLevel?.type === "BREAK" ||
                  (timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs < 0)
                )
              }
            >
              {timeInfo.remainingTimeInCurrentLevel}
            </S.UserTimer1TimerInfoTime>
            <div className="bottom">
              <div className="line" />
              <div className="item">
                <div className="title">레지 마감 레벨</div>
                <div
                  className={`value ${
                    timeInfo.currentLevel?.type === "BREAK" && "break "
                  }`}
                >
                  {data?.registerDeadlineLevel}LV
                </div>
              </div>
              <div className="line" />
              <div className="item">
                <div className="title">총 진행 시간</div>
                <div
                  className={`value2 ${
                    timeInfo.currentLevel?.type === "BREAK" && "break "
                  }`}
                >
                  {timeInfo.elapsedTime}
                </div>
              </div>
            </div>
          </S.UserTimer1TimerInfoWrapper>
          <S.UserTimer1BreakWrapper>
            <div className="title">다음 BREAK</div>
            <div className="value"> {timeInfo.timeUntilNextBreak}</div>
          </S.UserTimer1BreakWrapper>
          <S.UserTimer1BlindWrapper>
            <div className="title">현재 BLINDS</div>
            <div className="value">{getNowBlind()}</div>
          </S.UserTimer1BlindWrapper>
          <S.UserTimer1BlindWrapper style={{ height: "136px" }}>
            <div className="title">다음 BLINDS</div>
            <div className="value">{getNextBlind()}</div>
          </S.UserTimer1BlindWrapper>
        </S.UserTimer1LeftWrapper>

        <S.UserTimer1RightWrapper>
          <TimerPrizeAndNotice
            data={data}
            visibleRanks={visibleRanks}
            subPrizeFont={subPrizeFont}
          />

          <TimerCommonStack
            totalStack={formatNumber(stack)}
            avgStack={formatNumber(avgStack)}
            players={`${userCount} / ${
              adOnUserCount + reBuyInUserCount + entryUserCount
            }`}
          />
        </S.UserTimer1RightWrapper>
        {isAd && (
          <AdVideo
            coverImage={coverImage}
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </S.UserTimer1Wrapper>
      <CaptureButton
        onCapture={() => handleCapture(containerRef.current)}
        onCopyText={() => copyTournamentText(data, timeInfo)}
      />
    </>
  );
};

export default UserTimer1;
